import { useEffect } from 'react'
import { useRouter } from 'next/router'

// Libs
import { useAppDispatch } from '@/redux/hooks'
import { setShowLoading } from '@/redux/reducers/common'

// Constants
import { STORAGE_DATA } from '@/constants/storageData'
import { ROUTE_PATH } from '@/constants/routePath'

// Types

const AUTHORIZATION_PATH = [
  ROUTE_PATH.ORDERS,
  ROUTE_PATH.ORDER_RESULT,
  ROUTE_PATH.ME,
  ROUTE_PATH.MY_LIVE_FUTURE,
  ROUTE_PATH.MY_LIVE_PAST,
  ROUTE_PATH.MY_LIVE_RECORDS,
  ROUTE_PATH.HOME,
]

export const useAuthorization = () => {
  const router = useRouter()
  const { pathname } = router

  const dispatch = useAppDispatch()

  useEffect(() => {
    if (typeof window === 'undefined') return

    const tokenFromLocalStorage = JSON.parse(<string>window.localStorage.getItem(STORAGE_DATA.TOKEN))

    const isAuthorizationPath = AUTHORIZATION_PATH.includes(pathname)

    if (!tokenFromLocalStorage && isAuthorizationPath) {
      dispatch(setShowLoading({ showLoading: true }))
      router.push(ROUTE_PATH.LOGIN)
    }
  }, [pathname])
}
